'use client'
import React, { useEffect, useState } from 'react'
import CustomButton from './CustomButton'
import Image from 'next/image'
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import TiltedCard from './TiltedCard';
import Balatro from './Balatro';
import { useTrackButtonClick } from '@/hooks/useTrackButtonClick';


gsap.registerPlugin(ScrollTrigger);

const Hero = () => {
  const [cardWidth, setCardWidth] = useState("500px");

  // 👇 Detect screen height and update width
  useEffect(() => {
    const handleResize = () => {
      if (window.innerHeight <= 700) {
        setCardWidth("350px");
      } else {
        setCardWidth("500px");
      }
    };

    handleResize(); // run once on load
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useGSAP(() => {
    const overlay = document.getElementById("bg-overlay");

    if (overlay) {
      gsap.to(overlay, {
        opacity: 0.99,
        pointerEvents: "auto",
        ease: "power2.out",
        scrollTrigger: {
          trigger: "#home",
          start: "top top",
          end: "bottom 0",
          scrub: true,
        },
      });
    }
  }, []);

  const trackButtonClick = useTrackButtonClick();

  return (
    <section
      id="home"
      className="w-full min-h-dynamic flex flex-col justify-center items-center text-white"
    >
      <div className='relative w-full min-h-dynamic'>
        {/* Background Shader */}
        <div className="absolute inset-0 -z-10 w-full">
          <Balatro
            isRotate={true}
            pixelFilter={1500}
          />
          {/* Overlay to darken */}
          <div
            id="bg-overlay"
            className="absolute inset-0 bg-black opacity-0 pointer-events-none"
          />
        </div>

        {/* Hero Content */}
        <div className='w-full h-full absolute inset-0'>
          <div className="w-full h-full flex flex-col justify-center items-center md:px-16 px-4 max-w-6xl text-center mx-auto my-auto">
            {/* Hero Image */}
            <div className="flex justify-center w-full">
              <TiltedCard
                imageSrc="/heroCard.png"
                width={cardWidth}
                height="100%"
                scaleOnHover={1.05}
                rotateAmplitude={10}
                overlayContent={
                  <div className="px-6 py-3 rounded-xl bg-black/60 backdrop-blur-xl border border-white/80 shadow-lg">
                    <span className="text-3xl font-bold text-yellow-400 drop-shadow-[2px_2px_2px_rgba(0,0,0,0.9)]">
                      EVONIX VENTURES
                    </span>
                  </div>
                }
                displayOverlayContent={true}
              />
            </div>

            {/* Heading & Description */}
            <div className="max-w-3xl">
              <h1 className="text-3xl lg:text-5xl font-bold text-yellow-400 drop-shadow-[2px_2px_2px_rgba(0,0,0,0.9)] mb-4 lg:mb-6">
                Discover Classics Reimagined!
              </h1>
              <p className="text-lg lg:text-2xl font-semibold drop-shadow-[2px_2px_2px_rgba(0,0,0,0.9)]">
                Evonix Ventures brings you the most beloved games from around the world, that people play and enjoy for years.
              </p>
            </div>

            {/* Button */}
            <div className="mt-8">
              <CustomButton
                variant="primary"
                leftIcon={
                  <Image
                    src="/google play.png"
                    alt="Google Play"
                    width={20}
                    height={20}
                  />
                }
                onClick={() => {
                  window.open("https://play.google.com/store/apps/dev?id=8359109225809005026");
                  trackButtonClick("Google Play Button");
                }}
                ariaLabel='Google Play'
                title="Google Play"
              >
                Google Play
              </CustomButton>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
